@if (details || payment) {
  <div class="container-details">
    <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      {{ 'medicalConsultationsDetail.back' | translate }}
    </div>
    @if (details) {
      <div class="header">
        <i></i>
        <p class="title">{{ 'medicalConsultationsDetail.title' | translate }}</p>
      </div>
      <nz-card nzBordered="false" class="card" [nzBodyStyle]="{ padding: '0' }">
        <div class="header">
          <p>{{ 'medicalConsultationsDetail.header' | translate }}</p>
          <nz-divider></nz-divider>
        </div>
        <div class="inner-details-container">
          <div nz-row [nzGutter]="16">
            @if (isPathway) {
              <div class="info" nz-col nzSm="7" nzSpan="12">
                <p class="title">{{ 'medicalConsultationsDetail.visitNumber' | translate }}</p>
                <p class="value">{{ details.numberOfSessions >= 0 ? details.numberOfSessions : '-' }}</p>
              </div>
            } @else {
              <div class="info" nz-col nzSm="7" nzSpan="12">
                <p class="title">{{ 'medicalConsultationsDetail.date' | translate }}</p>
                <p class="value">
                  {{
                    details?.appointments[0]?.appointmentStartDate
                      ? formatAppointmentStartDateDocuments(details?.appointments[0]?.appointmentStartDate)
                      : details?.appointments[0]?.consultDate
                        ? formatDateDocuments(details?.appointments[0]?.consultDate)
                        : 'Medico Generico'
                  }}
                </p>
              </div>
            }
            <div class="info" nz-col nzSm="7" nzSpan="12">
              <p class="title">{{ 'medicalConsultationsDetail.type' | translate }}</p>
              <p class="value">{{ details.consultType ? getType(details.consultType) : '-' }}</p>
            </div>
            <div class="info" nz-col nzSm="7" nzSpan="12">
              <p class="title">{{ 'medicalConsultationsDetail.dossierCode' | translate }}</p>
              <p class="value">
                {{ details?.appointments[0]?.dossierCode ? details?.appointments[0]?.dossierCode : '-' }}
              </p>
            </div>
          </div>
          <div nz-row [nzGutter]="16">
            <div class="info" nz-col nzSm="7" nzSpan="12">
              <p class="title">{{ 'medicalConsultationsDetail.prestation' | translate }}</p>
              <p class="value">{{ details.consultType ? getPrestation(details.consultType) : '-' }}</p>
            </div>
            <div *ngIf="details.appointments[0].nAppointment !== 0" class="info" nz-col nzSm="7" nzSpan="12">
              <p class="title">{{ 'medicalConsultationsDetail.nappointment' | translate }}</p>
              <p class="value">{{ details.appointments[0].nAppointment }}</p>
            </div>
          </div>
        </div>
      </nz-card>
      @if (details.appointments[0].medicalRecordDocuments && !isPathway) {
        <div class="container-download">
          <div class="header">
            <p>{{ 'medicalConsultationsDetail.documents' | translate }}</p>
            <nz-divider></nz-divider>
          </div>
          <div nz-row class="documents-row">
            @for (document of details.appointments[0].medicalRecordDocuments; track document) {
              <div nz-col>
                <nz-card class="download-card" nzBordered="false" [nzBodyStyle]="{ padding: '0' }">
                  <div class="file-info" (click)="downloadFile(document)">
                    <div class="mobile-container">
                      <span nz-icon nzType="file" class="file-icon"></span>
                      <p class="file-name">{{ document.documentName }}</p>
                    </div>
                    <p class="file-meta">{{ formatAppointmentStartDateDocuments(document.documentDate) }}</p>
                  </div>
                </nz-card>
              </div>
            }
          </div>
        </div>
      }
      <div class="valutation-container">
        <div class="header">
          <p>{{ 'medicalConsultationsDetail.diagnosticTitle' | translate }}</p>
          <nz-divider></nz-divider>
        </div>
        <div class="info" nz-col nzSpan="24">
          <p class="title">{{ 'medicalConsultationsDetail.visitReason' | translate }}</p>
          <p class="value">{{ details?.message ?? '-' }}</p>
        </div>
      </div>
      @if (!isPathway) {
        <div class="valutation-container">
          <div class="header">
            <p>{{ 'medicalConsultationsDetail.docValutationsTitle' | translate }}</p>
            <nz-divider></nz-divider>
          </div>
          <div style="gap: 16px" nz-row>
            <div class="info" nz-col nzSpan="24">
              <p class="title">{{ 'medicalConsultationsDetail.docNote' | translate }}</p>
              <p class="value">{{ details?.appointments[0]?.medicalMessageResponse }}</p>
            </div>
          </div>
        </div>
      }
      @if (details.appointments && isPathway) {
        <div class="visit-recap-container">
          <div class="header">
            <p>{{ 'medicalConsultationsDetail.visitDetail' | translate }}</p>
            <nz-divider></nz-divider>
          </div>
          @for (data of details.appointments; track data) {
            <nz-collapse class="collapse" nzGhost>
              <nz-collapse-panel [nzHeader]="headerTemplate" [nzActive]="false" [nzShowArrow]="true" [nzExtra]="tagTemplate">
                <nz-divider></nz-divider>
                <div nz-row class="documents-row">
                  <div class="info" nz-col nzSpan="24">
                    <p class="title">{{ 'medicalConsultationsDetail.docNote' | translate }}</p>
                    <p class="value">{{ data.medicalMessageResponse }}</p>
                  </div>
                  <div class="documents">
                    @for (document of data.medicalRecordDocuments; track document) {
                      <div nz-col>
                        <nz-card class="download-card" nzBordered="false" [nzBodyStyle]="{ padding: '0' }">
                          <div class="file-info" (click)="downloadFile(document)">
                            <div class="mobile-container">
                              <span nz-icon nzType="file" class="file-icon"></span>
                              <p class="file-name">{{ document.documentName }}</p>
                            </div>
                            <p class="file-meta">{{ formatAppointmentStartDateDocuments(document.documentDate) }}</p>
                          </div>
                        </nz-card>
                      </div>
                    }
                    <div nz-col class="link" nz-col>
                      <a href="/medical-consultations/appointments-detail/{{ data?.consultRequestId }}">{{ 'medicalConsultationsDetail.moreDetails' | translate }}</a>
                    </div>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
            <nz-divider></nz-divider>
            <ng-template #headerTemplate>
              <span class="number">Visita {{ data.nAppointment }} / {{ details.appointments.length }}</span>
              <span class="date">{{ data?.appointmentStartDate ? formatAppointmentStartDateDocuments(data?.appointmentStartDate) : formatDateDocuments(data?.consultDate) }}</span>
            </ng-template>
            <ng-template #tagTemplate>
              <div class="state-container">
                @if (data.medicalRecordDocuments.length > 0) {
                  <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
                }
                <nz-badge [style]="getBadgeBackground(data.status)" [nzStatus]="getBadgeStatus(data.status)" [nzText]="data.status"></nz-badge>
              </div>
            </ng-template>
          }
        </div>
      }
    }
    @if (payment) {
      <div class="header">
        <i></i>
        <p class="title">{{ 'paymentDetail.title' | translate }}</p>
      </div>
      <div>
        <div class="header">
          <p>{{ 'paymentDetail.header' | translate }}</p>
          <nz-divider></nz-divider>
        </div>
        <nz-card nzBordered="false" class="card" [nzBodyStyle]="{ padding: '0' }">
          <div class="inner-details-container">
            <div nz-row [nzGutter]="16">
              <div class="info" nz-col nzSm="7" nzSpan="12">
                <p class="title">{{ 'paymentDetail.visitNumber' | translate }}</p>
                <p class="value">{{ payment.description ? payment.description : '-' }}</p>
              </div>
            </div>
            <div nz-row [nzGutter]="16">
              <div class="info" nz-col nzSm="7" nzSpan="12">
                <p class="title">{{ 'paymentDetail.prestation' | translate }}</p>
                <p class="value">{{ payment.serviceName ? payment.serviceName : '-' }}</p>
              </div>
              <div class="info" nz-col nzSm="7" nzSpan="12">
                <p class="title">{{ 'paymentDetail.rate' | translate }}</p>
                <p class="value">{{ payment.rateGrosAmount ? payment.rateGrosAmount : '-' }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </div>
      <div>
        <div class="header">
          <p>{{ 'paymentDetail.esit' | translate }}</p>
          <nz-divider></nz-divider>
        </div>
        <div class="esit-container">
          <div class="esit">
            <p class="title">{{ 'paymentDetail.prestation' | translate }}</p>
            <nz-badge [style]="getBadgeBackground(payment.state)" [nzStatus]="getBadgeStatus(payment.state)" [nzText]="'paymentDetail.' + payment.state | translate"></nz-badge>
          </div>
          <div class="esit">
            <p class="title">{{ 'paymentDetail.date' | translate }}</p>
            <p class="value">{{ payment.transactionDate ? parseCustomDate(payment.transactionDate) : '-' }}</p>
          </div>
          <div class="esit">
            <p class="title">{{ 'paymentDetail.transaction' | translate }}</p>
            <p class="value">{{ payment.transactionId ? payment.transactionId : '-' }}</p>
          </div>
          <div class="esit">
            <p class="title">{{ 'paymentDetail.circuit' | translate }}</p>
            <p class="value">{{ payment.circuit ? payment.circuit : '-' }}</p>
          </div>
        </div>
      </div>
    }
    <div class="text-aligne">
      <button class="btn-back" [routerLink]="['../..']">
        {{ 'medicalConsultationsDetail.back' | translate }}
      </button>
    </div>
  </div>
}
